import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EditService} from '../shared/services/editService/edit.service';
import {FormBuilder, Validators} from '@angular/forms';
import {SportTypesService} from '../shared/services/databaseServices/sportTypes/sport-types.service';
import {DatePipe} from '@angular/common';
import {Race} from '../shared/classes/Race';
import {SportType} from '../shared/classes/SportType';
import {StartFee} from '../shared/classes/StartFee';
import {StartFeeData} from '../shared/classes/StartFeeData';
import {Fee} from '../shared/classes/Fee';
import {faPen, faSave} from '@fortawesome/free-solid-svg-icons';
import {CatTrack} from '../shared/classes/CatTrack';
import {Category} from '../shared/classes/Category';
import {CatTrackService} from '../shared/services/databaseServices/catTrackService/cat-track.service';
import {tick} from '@angular/core/testing';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';

@Component({
  selector: 'app-start-fee',
  templateUrl: './start-fee.component.html',
  styleUrls: ['./start-fee.component.css'],
  providers: [DatePipe]
})
export class StartFeeComponent implements OnInit {

  private static NEW_ID = 'new';

  id = undefined;
  isNew = false;
  raceId = undefined;
  race: Race = undefined;
  faPencil = faPen;
  faSave = faSave;

  plusButton = true;
  editButton = false;

  createTooltip = 'raceDetailPage.startFeeTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.startFeeTab.deleteToolTip';
  addTooltip = 'raceDetailPage.startFeeTab.addToolTip';

  startFees: StartFee[] = [];
  waves: any[] = [];

  displayedColumns: string[] = ['category', 'money'];

  header = [
    {
      defName: 'category',
      translation: 'raceDetailPage.startFeeTab.category',
      elem: 'category'
    },
    {
      defName: 'money',
      translation: 'raceDetailPage.startFeeTab.money',
      elem: 'money'
    }
  ];

  displayColumnsCat: string[] = ['track'];
  dataSource = [];
  catTrack: CatTrack[] = [];
  categories: Category[] = [];

  public startFeeForm = this.formBuilder.group({
    number: ['', [Validators.required]],
    startDate: ['', [Validators.required]],
    finishDate: ['', [Validators.required]]
  });

  public forms = [];

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private catTrackService: CatTrackService,
              private racesService: RacesService,
              private editService: EditService,
              private formBuilder: FormBuilder,
              private sportTypesService: SportTypesService,
              private datePipe: DatePipe) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if(this.id === StartFeeComponent.NEW_ID) {
      this.id = this.racesService.lastSave;
    }
    this.isNew = this.id === StartFeeComponent.NEW_ID;
    if(this.isNew) {
      this.raceId = undefined;
      this.racesService.getOne(this.racesService.lastSave).then( data => {
        this.raceId = data.id;
        this.createRace(data);
        this.race.categories.forEach( cat => {
          this.categories.push(cat);
          this.displayColumnsCat.push(cat.name);
        });
        this.race.track.forEach(t => {
          const trackData = [];
          for (let catIndex = 0; catIndex < this.displayColumnsCat.length; catIndex++) {
            trackData[this.displayColumnsCat[catIndex]] = catIndex === 0 ? t.track + ', zkratka: '  + t.trackShort  : false;
          }
          this.dataSource.push(trackData);
        });
        this.transformStartFee();
        this.createFormForCat();
      });
    } else {
      this.racesService.getOne(this.id).then(data => {
        this.raceId = data.id;
        this.createRace(data);
        this.race.categories.forEach( cat => {
          this.categories.push(cat);
          this.displayColumnsCat.push(cat.name);
        });
        // this.race.track.forEach(t => {
        //   const catT: CatTrack = new CatTrack();
        //   catT.track = t;
        //   catT.cat = this.categories;
        //   const trackData = {};
        //   for (let catIndex = 0; catIndex < this.displayColumnsCat.length; catIndex++) {
        //     trackData[this.displayColumnsCat[catIndex] + ''] = catIndex === 0 ? t.track + ', zkratka: '  + t.trackShort : false;
        //   }
        //   this.dataSource.push(trackData);
        //   this.catTrack.push(catT);
        // });

        this.loadCatTrack();
        // console.dir(this.catTrack);
        // console.dir(this.dataSource);
        this.transformStartFee();
        this.createFormForCat();
      });
    }
  }

  private loadCatTrack() {
    console.dir(this.raceId);
    this.catTrackService.readOne(this.raceId).then(data => {
      console.dir(data.data());
      this.catTrack = [];
      for ( const c in data.data()) {
        this.catTrack.push(data.data()[c]);
      }
      this.catTrack.forEach(t => {
        const trackData = {};
        for (let catIndex = 0; catIndex < this.displayColumnsCat.length; catIndex++) {
          if (catIndex === 0) {
            trackData[this.displayColumnsCat[catIndex]] = t.track.track + ', zkratka: '  + t.track.trackShort;
          }
          t.cat.forEach(cat => {
            if (cat.name === this.displayColumnsCat[catIndex]) {
              trackData[this.displayColumnsCat[catIndex]] = cat.available;
            }
          });
        }
        this.dataSource.push(trackData);
      });
    });
  }

  edit(e) {
    let startFee: StartFee = this.startFees.filter( item => item.num === e.num)[0];
    this.startFeeForm.patchValue({ number: startFee.num, startDate: startFee.startDate.toDate(), finishDate: startFee.finishDate.toDate() });
    this.forms = [];
    startFee.data.forEach(item => {
      const form = this.formBuilder.group({
        name: [item.category, []],
        money: [item.fee[0].money, [Validators.required]],
        currency: [item.fee[0].currency, [Validators.required]]
      });
      form.get('name').disable();
      this.forms.push(form);
    });

    // this.race.categories.forEach(item => {
    //   const form = this.formBuilder.group({
    //     name: [item.name, []],
    //     money: ['0', [Validators.required]],
    //     currency: ['Kč', [Validators.required]],
    //   });
    //   form.get('name').disable();
    //   this.forms.push(form);
    // });


    this.toggleButton();

  }

  saveCatTrack() {
    const toSave: CatTrack[] = [];
    this.dataSource.forEach(data => {
      const name = data.track.replace(', zkratka: ', '/');

      let ct: CatTrack = this.catTrack.filter(catT => `${catT.track.track}/${catT.track.trackShort}` === name)[0];

      for (let catIndex = 1; catIndex < this.displayColumnsCat.length; catIndex++) {
        const value = data[this.displayColumnsCat[catIndex]];
        ct.cat = ct.cat.map(cMap => {
          if (cMap.name ===  this.displayColumnsCat[catIndex]){
            cMap.available = value;
          }
          return cMap;
        });
      }
      toSave.push(ct);
    });

    this.catTrackService.create(this.raceId, toSave)
      .then( () => {
        console.log('okk');
      })
      .catch((err) => {
        console.dir(err);
      });
  }

  private transformStartFee(){
    this.startFees = this.race === undefined ? [] : this.race.startFee;
    const waves: any[] = [];
    this.startFees.forEach(wave => {
      const list: any[] = [];
      const workList: any[] = [];
      wave.data.forEach(item => {
        const cat = item.category;
        item.fee.forEach( fee => {
          const obj = { category: cat, money: `${fee.money} ${fee.currency}` };
          list.push(obj);
        });
      });
      const mainObj = {
        wave: `Vlna: ${wave.num}, datum: ${this.datePipe.transform(wave.startDate.toDate(), 'dd.MM.yyyy')} - ${this.datePipe.transform(wave.finishDate.toDate(), 'dd.MM.yyyy')}`,
        data: list,
        num: wave.num
      };
      waves.push(mainObj);
    });
    this.waves = waves;
  }

  private createFormForCat(){
    this.race.categories.forEach(item => {
      const form = this.formBuilder.group({
        name: [item.name, []],
        money: ['0', [Validators.required]],
        currency: ['Kč', [Validators.required]],
      });
      form.get('name').disable();
      this.forms.push(form);
    });
  }

  private createRace(object) {
    this.race = new Race();
    this.race.id = object.id;
    const item = object.data();
    this.race.name = item.name;
    this.race.dateStart = item.dateStart;
    this.race.dateFinish = item.dateFinish;
    this.race.dateOfReg = item.dateOfReg;
    this.race.track = item.track;
    this.race.defaultCat = item.defaultCat;
    this.race.categories = item.categories;
    this.race.web = item.web;
    this.race.location = item.location;
    this.race.sameDate = item.sameDate;
    this.race.sportType = item.sportType;
    this.race.organizer = item.organizer;
    this.race.emailOr = item.emailOr;
    this.race.mobileOr = item.mobileOr;
    this.race.fioConfig = item.fioConfig;
    this.race.detail = item.detail;
    this.race.startFee = item.startFee !== undefined ? item.startFee.sort((a, b) => {
      return a.num - b.num;
    }) : [];
    this.race.sportType.get().then( type => {
      const sportType = new SportType();
      sportType.id = type.id;
      sportType.type = type.data().type;
      sportType.category = type.data().category;
      this.race.sportType = sportType;

      console.dir(this.race);
    });
  }

  save(item){
    // this.isNew = false;
    const startFee = new StartFee();
    startFee.num = this.startFeeForm.get('number').value;
    startFee.startDate = new Date(this.startFeeForm.get('startDate').value);
    startFee.finishDate = new Date(this.startFeeForm.get('finishDate').value);
    startFee.data = [];

    this.forms.forEach( form => {
       const startFeeData = new StartFeeData();
       startFeeData.category = form.get('name').value;
       startFeeData.fee = [];
       const fee: Fee = new Fee();
       fee.money = form.get('money').value;
       fee.currency = form.get('currency').value;
       startFeeData.fee.push(fee);
       startFee.data.push(startFeeData);
    });
    this.race.startFee = this.race.startFee.filter(i => i.num !== startFee.num);
    this.race.startFee.push(startFee);
    console.dir(this.race.startFee);
    console.dir(this.race);
    this.racesService.update(this.race.id, this.race).then(() => {
      this.toggleButton();
      this.startFeeForm.reset();
      this.forms.forEach( form => form.reset());
      // this.transformStartFee();
      this.ngOnInit();
    }).catch(err => {
      console.dir(err);
    });
    this.forms = [];
  }

  delete(item){
    const startFee = new StartFee();
    startFee.num = this.startFeeForm.get('number').value;

    this.race.startFee = this.race.startFee.filter(i => i.num !== startFee.num);

    this.racesService.update(this.race.id, this.race).then(() => {
      this.toggleButton();
      this.startFeeForm.reset();
      this.forms.forEach( form => form.reset());
      // this.transformStartFee();
      this.ngOnInit();
    }).catch(err => {
      console.dir(err);
    });
  }

  add(item){
    this.toggleButton();
    // this.isNew = true;
  }

  private toggleButton() {
    this.plusButton = !this.plusButton;
    this.editButton = !this.editButton;
  }

  getTreeData(){
    return this.race.startFee.map( item => {
      const childrenNode = item.data.map( i => {
        return {name: i.category};
      });

      const obj = {
        name: `vlna: ${item.num}  datum: ${this.datePipe.transform(item.startDate.toDate(), 'dd.MM.yyyy')} - ${this.datePipe.transform(item.finishDate.toDate(), 'dd.MM.yyyy')}`,
        children: childrenNode
      };
      return obj;
    });
  }

  isEdit(){
    return this.editService.editable;
  }

}
